import {isFeatureEnabled} from '@github-ui/feature-flags'
import {useRouteQuery} from '@github-ui/react-core/future/use-route-query'
import {pullRequestsCommitsRoute} from '../routes/commits-route'
import {useRefetchOnAliveUpdate, type PullRequestAliveData} from './use-refetch-on-alive-update'
import {useInvalidateOnAliveUpdate} from './use-invalidate-on-alive-update'

const filter = (data: PullRequestAliveData) => Boolean(data.event_updates?.git_updated)

export function useCommitsLiveUpdates(channel: string, throttleTimeout?: number): void {
  const {refetch, queryKey} = useRouteQuery(pullRequestsCommitsRoute, 'mainQuery')
  const dedupeConcurrentRefetches = isFeatureEnabled('merge_status_checks_refetch_dedupe')

  // Original refetch path (flag OFF)
  useRefetchOnAliveUpdate(dedupeConcurrentRefetches ? '' : channel, refetch, {git_updated: true}, throttleTimeout)

  // Invalidation path (flag ON)
  useInvalidateOnAliveUpdate(dedupeConcurrentRefetches ? channel : '', queryKey, {filter, throttleTimeout})
}
